<template>
  <v-radio-group v-model="data" @change="setDataErrors()" column :readonly="!canEdit" :error-messages="dataErrors" row>
    <v-radio label="Sí" :value="1"></v-radio>
    <v-radio label="No" :value="0"></v-radio>
    <v-radio label="Sin responder" :value="2" v-show="requerimiento.optional"></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  props: {
    requerimiento: Object,
    canEdit: Boolean
  },

  data () {
    return {
      data: -1,
      dataErrors: []
    }
  },

  methods: {
    isValid () {
      this.setDataErrors()
      return this.hasSelectedOption()
    },
    setDataErrors () {
      this.dataErrors = []
      !this.hasSelectedOption() && this.dataErrors.push('Campo requerido.')
    },
    isModified () {
      return parseInt(this.requerimiento.data) !== this.data
    },
    getData () {
      return this.data
    },
    hasSelectedOption () {
      return this.data === 0 || this.data === 1 || (this.data === 2 && this.requerimiento.optional)
    }
  },

  created () {
    this.data = parseInt(this.requerimiento.data)
  }
}
</script>
